// UQ-es-ES
module.exports = {
  "forTest": "test for UQ-es-ES",
  "text_styling_book_header_title": "STYLING BOOK",
  "text_styling_book_official_styling": "Looks oficiales",
  "text_styling_book_stylehint": "StyleHint",
  "text_sort": "Ordenar por",
  "text_filter": "Filtrar",
  "text_styling_book_search_results_number": "{total} resultados",
  "text_active_filters": "Filtros activos",
  "text_styling_book_clear_all_filters": "Deseleccionar todo",
  "text_styling_book_search_by_feature": "Búsqueda por características",
  "text_styling_book_search_by_category": "Búsqueda por categoría",
  "text_styling_book_staff_customer_filter_all": "Todo",
  "text_styling_book_search_by_coordinate": "Búsqueda por coordenadas",
  "text_styling_book_staff_customer_filter_title": "Personal/Cliente",
  "text_styling_book_search_by_height": "Búsqueda por altura",
  "text_styling_book_search_by_hashtag": "Búsqueda por hashtag",
  "text_styling_book_staff_customer_filter_customer_styling": "Looks de los clientes",
  "text_styling_book_staff_customer_filter_staff_styling": "Looks del personal",
  "text_apply_search_filter": "Aplicar",
  "text_styling_book_no_results": "Ningún resultado",
  "text_error_title": "Servicio temporalmente no disponible",
  "text_503_error_description-1": "Lo sentimos, se ha producido un error.",
  "text_503_error_description-2": "Accede a este sitio más tarde o vuelve a la página anterior con el botón «Atrás» del navegador.",
  "text_503_error_instruction": "Si tienes alguna pregunta, visita {text_contactus}.",
  "text_styling_book_go_to_top": "Página de inicio de UNIQLO",
  "text_contactus": "Ponte en contacto con nosotros",
  "text_wishlist": "Lista de deseos",
  "text_membership_info": "Cuenta de usuario",
  "text_wearing_items": "Artículos para llevar",
  "text_color": "Color",
  "text_size": "Talla",
  "text_stylehint_non_listed_items_message_01": "Si un artículo no está incluido en la lista anterior, significa que está agotado o que no es un producto UNIQLO.",
  "text_styling_book_related_styling_title": "Looks relacionados",
  "text_style_styling_date_update": "Actualizar",
  "text_styling_book_hashtag_title": "Hashtag",
  "currency_format": "{price} €",
  "text_404": "Página no encontrada",
  "text_official_styling_top_page_link": "Looks oficiales",
  "text_stylehint_top_page_link": "StyleHint",
  "text_breadcrumbs_top": "Página de inicio de UNIQLO",
  "text_a11y_close": "Cerrar",
  "text_log_in": "Iniciar sesión",
  "text_app_update_dialog_cancel": "Cancelar",
  "text_menu": "Menú",
  "text_copyright": "Copyright © UNIQLO Co., Ltd. Todos los derechos reservados.",
  "text_stylehintapp": "StyleHint App",
  "text_styling_book_official_styling_page_title": "Looks oficiales",
  "text_styling_book_stylehint_page_title": "StyleHint",
  "text_styling_book_sort_latest": "Novedades",
  "text_styling_book_sort_popular": "Más populares",
  "text_styling_book_search_by_color": "Búsqueda por color",
  "text_filter_clear_all_category": "Deseleccionar todas las categorías",
  "text_styling_book_filter_height_over": "≧",
  "text_styling_book_filter_height_under": "≦",
  "text_show_all": "Mostrar todo",
  "text_error_description": "Se ha producido un error del sistema. Inténtalo de nuevo o vuelve más tarde.",
  "text_system_error": "Error del sistema",
  "text_ok": "OK",
  "text_login_required": "Es necesario iniciar sesión",
  "text_login_request": "Ve a la página de inicio de sesión.",
  "text_error_failed_sort_product": "No se han podido ordenar los productos con los criterios seleccionados. Vuelve a aplicar el orden.",
  "text_error_failed_update_filter_criteria": "No se han podido actualizar los criterios del filtro. Vuelve a intentarlo.",
  "text_meta_title_postfix": "| UNIQLO ES",
  "text_meta_title_prefix": "UNIQLO |",
  "text_styling_book_meta_title_brand": "UNIQLO",
  "text_styling_book_meta_women": "Mujer",
  "text_styling_book_meta_men": "Hombre",
  "text_styling_book_meta_kids": "Niños",
  "text_styling_book_meta_baby": "Bebés",
  "text_styling_book_official_gender_meta_description": "Explora el lookbook oficial de la marca. Navega por él y descubre looks de moda y consejos para combinar la colección {gender}.",
  "text_styling_book_official_gender_meta_title": "Descubre los looks actuales | {gender} | Lookbook oficial {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_title": "{gender}「{filterOptions} Ideas para combinar {uqPostfix}",
  "text_styling_book_official_gender_filter_meta_description": "Descubre ideas de looks para {gender} {filterOptions}」con modernos diseños de {brand}. Aprende a crear looks atemporales.",
  "text_styling_book_official_detail_meta_title": "Descubre los looks de {officialProducts}」{uqPostfix}",
  "text_styling_book_official_detail_meta_description": "Descubre los nuevos looks de la temporada para「{officialProducts}」y pide ya el conjunto completo en {brand}.com",
  "text_styling_book_stylehint_gender_meta_title": "Descubre nuevas ideas de looks | {gender} | StyleHint {uqPostfix}",
  "text_styling_book_stylehint_gender_meta_description": "¡Déjate inspirar! Explora los looks para {gender} de nuestros clientes y empleados de {brand} en la app StyleHint.",
  "text_styling_book_stylehint_filter_meta_title": "Ideas de looks para {gender}「{filterOptions}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_title": "Ideas de looks para {userName}({storeName}) {uqPostfix}",
  "text_styling_book_stylehint_ins_user_meta_title": "Ideas de looks para {userName} {uqPostfix}",
  "text_styling_book_stylehint_customer_user_meta_title": "Ideas de looks para {userName}({height}) {uqPostfix}",
  "text_styling_book_stylehint_detail_meta_title": "Descubre ideas de looks para「{stylehintProducts}」{uqPostfix}",
  "text_styling_book_stylehint_store_user_meta_description": "Descubre los looks de {staffName}({height}) de {brand}({storeName}). Descubre cómo nuestros empleados combinan looks a la perfección.",
  "text_styling_book_stylehint_ins_user_meta_description": "Descubre los looks de「{userName}」de Instagram con productos de {brand}, y ve cómo otros usuarios crean looks modernos.",
  "text_styling_book_stylehint_customer_user_meta_description": "Descubre los looks atemporales de {userName} ({height}) con productos de {brand}. Echa un vistazo a los artículos de la tienda online.",
  "text_styling_book_stylehint_detail_meta_description": "Descubre los nuevos looks de「{stylehintProducts}」de nuestros clientes y empleados en {brand}. Pide ya el conjunto completo en {brand}.com",
  "text_styling_book_stylehint_filter_meta_description": "Descubre「{searchCount}」looks de「{filterOptions}」con productos de {brand}. Descubre las últimas novedades y bestsellers online.",
  "text_styling_book_stylehint_styling_id_alt_tag": "{brand} LOOKBOOK ideas para combinar: <{styleId}>",
  "text_styling_book_official_styling_id_alt_tag": "{brand} LOOKBOOK ideas para combinar: <{styleId}>",
  "text_styling_book_official_detail_id_alt_tag": "Descubre para combinar de「{officialProducts}」",
  "text_styling_book_stylehint_detail_id_alt_tag": "Descubre los looks de「{stylehintProducts}」",
  "text_styling_book_product_id_alt_tag": "{productName} {gender}",
  "text_styling_book_stylehint_user_id_alt_tag": "{userName}",
  "text_styling_book_stylehint_hashtag_alt_tag": "Outfits für {gender}「{hashtag}」",
  "text_styling_book_stylehint_feature_alt_tag": "Ideas para combinar para {gender}「{feature}」",
  "text_style_model_height": "cm",
  "text_503_error_description": "Lo sentimos. Se ha producido un error. Accede a este sitio más tarde o vuelve a la página anterior con el botón «Atrás» del navegador.",
  "text_styling_book_meta_official_styling": "Ideas de estilismo",
  "text_styling_book_meta_stylehint": "Ideas de looks",
  "text_limited_offer_until_date": "Promoción hasta el {date}",
  "text_online_store_exclusive_limited_offer_until_date": "Promoción exclusiva en la tienda en línea hasta el {date}",
  "text_app_membership_exclusive_limited_offer_until": "Miembro de la aplicación limitado hasta el {date}",
  "text_csoon_early": "Disponible a principios de {month}",
  "text_csoon_mid": "Disponible a mediados de {month}",
  "text_csoon_late": "Disponible a finales de {month}",
  "text_men": "Hombre",
  "text_women": "Mujer",
  "text_kids": "Niños",
  "text_baby": "Bebés",
  "text_unisex": "Unisex",
  "text_app_membership_exclusive_limited_offer": "Miembro de la aplicación limitado",
  "text_styling_book_gender_menu_kids_and_baby": "Niños/Bebés",
  "text_styling_book_meta_kids_and_baby": "",
  "text_a11y_favorites_add": "Añadir a la lista de deseos",
  "text_close": "Cerrar",
  "text_error_wishlist_max": "No puedes añadir el artículo a tu lista de deseos dado que se ha excedido el máximo de 999 artículos en la lista de deseos.",
  "text_size_multiplication_sign": "✕",
  "text_no_image": "No hay imagen",
  "text_wearing_size_code01": "Lleva la talla: {size_code}",
  "text_locale_hk_zh": "",
  "text_locale_en": "English",
  "text_locale_fr": "",
  "text_locale_th": "",
  "text_locale_id": "",
  "text_locale_vi": "",
  "text_locale_de": "",
  "text_locale_es": "Español",
  "text_locale_it": "",
  "text_locale_nl": "",
  "text_product_unavailable": "Este producto ha sido descatalogado.",
  "text_product_display_markdown": "",
  "text_color_white": "Blanco",
  "text_color_gray": "Gris",
  "text_color_black": "Negro",
  "text_color_pink": "Rosa",
  "text_color_red": "Rojo",
  "text_color_orange": "Naranja",
  "text_color_beige": "Beige",
  "text_color_brown": "Marrón",
  "text_color_yellow": "Amarillo",
  "text_color_green": "Verde",
  "text_color_blue": "Azul",
  "text_color_purple": "Morado",
  "text_promotion": "Promoción",
  "text_styling_promotion_hashtag": "Promoción",
  "text_coming_soon": "Próximamente",
  "text_markdown": "Producto rebajado",
  "text_multibuy_markdown": "Compra múltiple, producto rebajado",
  "text_multibuy_limited_offer_until_date": "Compra múltiple, promoción hasta el {date}",
  "text_app_membership_exclusive_multi_buy_until": "Ofertas multicompra online y ofertas exclusivas en la app hasta el {date}.",
  "text_app_membership_exclusive_multi_buy": "Ofertas multicompra online y ofertas exclusivas en la app",
  "text_app_membership_exclusive_limitedoffers_until": "Online y ofertas exclusivas en la app hasta el {date}.",
  "text_item_preorder_color_size_only": "",
  "text_item_resale_color_size_only": ""
}; // generated at Thu Sep 26 2024 09:27:54 GMT+0800 (Hong Kong Standard Time)